import { alpha } from '@mui/material/styles'

import { getColors } from '@utils/StylesHelper'

function getColorStyle({ color, theme }) {
  const colors = getColors(theme, color)
  const { main, dark } = colors

  return {
    '&:hover': {
      backgroundColor: alpha(main, 0.08),
      '& .icon': {
        borderColor: main,
      },
    },
    '&.Mui-focusVisible': {
      outline: `2px solid ${alpha(dark, 0.5)}`,
      outlineOffset: -4,
    },
  }
}

export default function Checkbox(theme) {
  return {
    MuiCheckbox: {
      defaultProps: {
        className: 'size-small',
      },
      styleOverrides: {
        root: {
          color: theme.palette.grey[500],
        },
        colorPrimary: getColorStyle({ color: 'primary', theme }),
        colorSecondary: getColorStyle({ color: 'secondary', theme }),
        colorSuccess: getColorStyle({ color: 'success', theme }),
        colorWarning: getColorStyle({ color: 'warning', theme }),
        colorInfo: getColorStyle({ color: 'info', theme }),
        colorError: getColorStyle({ color: 'error', theme }),
      },
    },
  }
}
